export type AppEnv = 'PROD' | 'PREPROD' | 'STAGING' | 'QA'

/**
 * Resolve app environment for API base URLs.
 * Prefer VITE_ENV; never use Vite's MODE ("development"/"production") as API env.
 */
export function getAppEnv(): AppEnv {
  const raw = import.meta.env.VITE_ENV
  if (raw == null || raw === '') return 'PREPROD'
  const upper = String(raw).toUpperCase()
  if (upper === 'PROD' || upper === 'PREPROD' || upper === 'STAGING' || upper === 'QA') {
    return upper as AppEnv
  }
  return 'PREPROD'
}

export function isProd(): boolean {
  return getAppEnv() === 'PROD'
}
